export const MODULE_OBJECT_KEY = "module"
